import { render, staticRenderFns } from "./BaseMitReservationReadOnly.vue?vue&type=template&id=84b7e86e&scoped=true"
import script from "./BaseMitReservationReadOnly.vue?vue&type=script&lang=js"
export * from "./BaseMitReservationReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b7e86e",
  null
  
)

export default component.exports